/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react';
import { GlobalContext } from '../context/globalContext';
import { Link } from 'react-router-dom';

const Footer = () => {
  const { locale } = useContext(GlobalContext);

  return (
    <>
      <footer className="footer footer-center p-10 text-base-content dark:bg-gray-500 dark:text-gray-200 bg-transparent">
        {/* Links */}
        <div className="grid grid-flow-col gap-4">
          <Link to="/home">
            <a className="link link-hover">
              {locale === 'ID' ? 'Beranda' : 'Home'}
            </a>
          </Link>
          <Link to="/project">
            <a className="link link-hover">
              {locale === 'ID' ? 'Proyek' : 'Projects'}
            </a>
          </Link>
          <Link to="/about">
            <a className="link link-hover">
              {locale === 'ID' ? 'Tentang' : 'About'}
            </a>
          </Link>
          <Link to="/contact">
            <a className="link link-hover">
              {locale === 'ID' ? 'Kontak' : 'Contact'}
            </a>
          </Link>
        </div>
        {/* Logo */}
        <div>
          <div className="grid grid-flow-col gap-4">
            <a
              href="https://www.twitter.com/KkBwk"
              target="_blank"
              rel="noreferrer"
              className="transition-all duration-300 hover:-translate-y-1 "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon icon-tabler icon-tabler-brand-twitter dark:text-gray-100"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="#000000"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M22 4.01c-1 .49 -1.98 .689 -3 .99c-1.121 -1.265 -2.783 -1.335 -4.38 -.737s-2.643 2.06 -2.62 3.737v1c-3.245 .083 -6.135 -1.395 -8 -4c0 0 -4.182 7.433 4 11c-1.872 1.247 -3.739 2.088 -6 2c3.308 1.803 6.913 2.423 10.034 1.517c3.58 -1.04 6.522 -3.723 7.651 -7.742a13.84 13.84 0 0 0 .497 -3.753c-.002 -.249 1.51 -2.772 1.818 -4.013z" />
              </svg>
            </a>
            <a
              href="https://github.com/KakaBewok"
              target="_blank"
              rel="noreferrer"
              className="transition-all duration-300 hover:-translate-y-1"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon icon-tabler icon-tabler-brand-github"
                width="26"
                height="26"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="#000000"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M9 19c-4.3 1.4 -4.3 -2.5 -6 -3m12 5v-3.5c0 -1 .1 -1.4 -.5 -2c2.8 -.3 5.5 -1.4 5.5 -6a4.6 4.6 0 0 0 -1.3 -3.2a4.2 4.2 0 0 0 -.1 -3.2s-1.1 -.3 -3.5 1.3a12.3 12.3 0 0 0 -6.2 0c-2.4 -1.6 -3.5 -1.3 -3.5 -1.3a4.2 4.2 0 0 0 -.1 3.2a4.6 4.6 0 0 0 -1.3 3.2c0 4.6 2.7 5.7 5.5 6c-.6 .6 -.6 1.2 -.5 2v3.5" />
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/in/noprizal/"
              target="_blank"
              rel="noreferrer"
              className="transition-all duration-300 hover:-translate-y-1"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon icon-tabler icon-tabler-brand-linkedin"
                width="30"
                height="30"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="#000000"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <rect x="4" y="4" width="16" height="16" rx="2" />
                <line x1="8" y1="11" x2="8" y2="16" />
                <line x1="8" y1="8" x2="8" y2="8.01" />
                <line x1="12" y1="16" x2="12" y2="11" />
                <path d="M16 16v-3a2 2 0 0 0 -4 0" />
              </svg>
            </a>
          </div>
        </div>
        {/* Float button */}
        <a
          href="#"
          className="animate-bounce w-6 h-6 fixed right-10 top-[90%] border-none"
        >
          <button className="btn btn-circle bg-sky-500 border-none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="icon icon-tabler icon-tabler-arrow-up-circle"
              width="40"
              height="40"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="#FFFFFF"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <circle cx="12" cy="12" r="9" />
              <line x1="12" y1="8" x2="8" y2="12" />
              <line x1="12" y1="8" x2="12" y2="16" />
              <line x1="16" y1="12" x2="12" y2="8" />
            </svg>
          </button>
        </a>
        <div>
          <p>Copyright © 2023 - All right reserved by Noprizal</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
